import http from '@/requests/http'
import appConfig from '@/config/app'
import utilityHelper from '@/helpers/utils'

class Member {
  static all (params) {
    return http.post('member', params)
  }
  static list (params) {
    return http.post('member/list', params)
  }
  static async update (data) {
    return http.post('member/update', data)
  }
  static async view (params) {
    return http.post('member/view', params)
  }
  static async save (data) {
    return http.post('member/store', data)
  }
  static async delete (id) {
    return http.post(`member/delete/${id}`)
  }
  static findMemberByCompanyName (companyName) {
    return http.post(`member/company/${companyName}`)
  }
  static findMemberByPhoneNumber (phoneNumber) {
    return http.post(`member/phone-number/${phoneNumber}`)
  }
  static findMemberById (id) {
    return http.post(`member/${id}`)
  }
  static async saveCaller (data) {
    return http.post('member/store/caller', data)
  }
  static async getSettings (data) {
    return http.post('member/get-settings', data)
  }
  static async getMembers (phoneNumber) {
    return http.post(`member/list/${phoneNumber}`)
  }
  static async export (params) {
    const URLparams = new URLSearchParams(Object.entries(params))
    window.open(`${appConfig.apiBaseUrl  }/member/export?${URLparams}`, '_blank')
  }
  static async downloadSampleImportFile (id, language) {
    window.open(`${appConfig.apiBaseUrl  }/member/import/${id}/sample/${language}`, '_blank')
  }
  static async import (data) {
    const formData = new FormData()
    await utilityHelper.buildFormData(formData, data)
    return http.post('member/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export default Member
